import { Link } from 'react-router-dom';
import { dimensions } from '@/mocks/dimensions';

export default function DimensionGrid() {
  return (
    <section id="dimensions" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-14 md:px-8 md:py-20">
        <div className="flex flex-col gap-4 border-b border-background-200 pb-8 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-xs tracking-[0.3em] text-primary-600">四个维度 / DIMENSIONS</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              一条爆料，从四个角度拆开
            </h2>
          </div>
          <p className="max-w-md font-body text-sm leading-relaxed text-foreground-600">
            四个维度各有侧重，但共用同一份素材。你可以只看自己关心的那一层，也可以顺着四层往下走完一整条脉络。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {dimensions.map((dimension, index) => (
            <Link
              key={dimension.id}
              to={`/dossiers?dimension=${dimension.id}`}
              className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-6 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-md bg-background-200 text-foreground-900 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${dimension.icon} text-xl`} />
                </span>
                <span className="font-heading text-2xl font-bold text-background-300">{String(index + 1).padStart(2, '0')}</span>
              </div>
              <h3 className="mt-6 font-heading text-lg font-semibold text-foreground-950">{dimension.name}</h3>
              <p className="mt-3 font-body text-sm leading-relaxed text-foreground-600">{dimension.desc}</p>
              <span className="mt-6 inline-flex items-center gap-1.5 font-label text-xs text-primary-600">
                查看该维度档案
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}